var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProspectMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10796_22345)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10796_22345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_10796_22345",
    maskUnits: "userSpaceOnUse",
    x: 14.45,
    y: 6,
    width: 52,
    height: 68,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 14.45,
    y: 6,
    width: 52,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5409 31.7826C62.5409 25.7403 60.1656 19.9455 55.9375 15.6729C51.7094 11.4003 45.9749 9 39.9955 9C34.016 9 28.2815 11.4003 24.0534 15.6729C19.8253 19.9455 17.45 25.7403 17.45 31.7826C17.4502 37.4644 19.5613 42.9391 23.3655 47.123C23.3655 47.123 35.744 60.8902 39.158 70.383C39.2188 70.563 39.3338 70.7192 39.4868 70.8299C39.6399 70.9405 39.8234 71 40.0116 71C40.1997 71 40.3832 70.9405 40.5363 70.8299C40.6893 70.7192 40.8043 70.563 40.8651 70.383C44.2791 60.8902 56.6469 47.123 56.6469 47.123C60.4442 42.9364 62.5476 37.4617 62.5409 31.7826Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.5409 31.7826C62.5409 25.7403 60.1656 19.9455 55.9375 15.6729C51.7094 11.4003 45.9749 9 39.9955 9C34.016 9 28.2815 11.4003 24.0534 15.6729C19.8253 19.9455 17.45 25.7403 17.45 31.7826C17.4502 37.4644 19.5613 42.9391 23.3655 47.123C23.3655 47.123 35.744 60.8902 39.158 70.383C39.2188 70.563 39.3338 70.7192 39.4868 70.8299C39.6399 70.9405 39.8234 71 40.0116 71C40.1997 71 40.3832 70.9405 40.5363 70.8299C40.6893 70.7192 40.8043 70.563 40.8651 70.383C44.2791 60.8902 56.6469 47.123 56.6469 47.123C60.4442 42.9364 62.5476 37.4617 62.5409 31.7826Z",
    fill: "#1F2647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5409 31.7826C62.5409 25.7403 60.1656 19.9455 55.9375 15.6729C51.7094 11.4003 45.9749 9 39.9955 9C34.016 9 28.2815 11.4003 24.0534 15.6729C19.8253 19.9455 17.45 25.7403 17.45 31.7826C17.4502 37.4644 19.5613 42.9391 23.3655 47.123C23.3655 47.123 35.744 60.8902 39.158 70.383C39.2188 70.563 39.3338 70.7192 39.4868 70.8299C39.6399 70.9405 39.8234 71 40.0116 71C40.1997 71 40.3832 70.9405 40.5363 70.8299C40.6893 70.7192 40.8043 70.563 40.8651 70.383C44.2791 60.8902 56.6469 47.123 56.6469 47.123C60.4442 42.9364 62.5476 37.4617 62.5409 31.7826Z",
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-1-outside-1_10796_22345)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.79 39.4881H37.5183V32.6052C37.5183 32.1453 37.8236 31.8583 38.2703 31.8583H42.0471C42.5029 31.8583 42.79 32.1453 42.79 32.6052V39.4881ZM31.1575 38.7733C31.1575 40.142 31.9833 40.9497 33.3702 40.9497H46.9727C48.3595 40.9497 49.1853 40.142 49.1853 38.7733V30.2726L40.7947 23.2392C40.3898 22.8859 39.9317 22.8991 39.54 23.2392L31.1575 30.2644V38.7733ZM28.0754 29.4938C28.0754 29.8662 28.3711 30.2164 28.8606 30.2164C29.1119 30.2164 29.3147 30.0812 29.4984 29.9288L39.7826 21.2893C40.0306 21.0808 40.3059 21.0735 40.5602 21.2893L50.8281 29.9288C51.0209 30.0812 51.2237 30.2164 51.475 30.2164C51.905 30.2164 52.242 29.9479 52.242 29.521C52.242 29.2434 52.1572 29.0597 51.9522 28.8901L41.3508 19.9715C40.6211 19.3529 39.739 19.3529 39.0011 19.9715L28.3743 28.8901C28.1693 29.0597 28.0754 29.2797 28.0754 29.4938ZM46.7851 25.1294L49.1853 27.1518V22.3977C49.1853 21.9876 48.9096 21.725 48.5086 21.725H47.4759C47.07 21.725 46.7851 21.9876 46.7851 22.3977V25.1294Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10796_22345",
    x: 7.39278,
    y: -1.05724,
    width: 65.2054,
    height: 82.1145,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.52862
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.121569 0 0 0 0 0.14902 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10796_22345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10796_22345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10796_22345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProspectMapPin);
export default __webpack_public_path__ + "static/media/prospect-map-pin.34067e8ff856d3cc82629d1715e9ed5c.svg";
export { ForwardRef as ReactComponent };